import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconRefreshComponent } from "./med-icon-refresh.component";

@NgModule({
  declarations: [
    MedIconRefreshComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconRefreshComponent,
  ],
})
export class MedIconRefreshModule { }
